export default __webpack_public_path__ + "static/media/women.835fc8a1.png";